// import then needed Font Awesome functionality
import {library, dom} from '@fortawesome/fontawesome-svg-core';

// import the Facebook and Twitter icons
import {fab} from '@fortawesome/free-brands-svg-icons';
import {
	faGlobe,
	faTh,
	faStop,
	faPlay,
	faPause,
	faArrowLeft,
	faArrowRight,
	faArrowUp,
	faArrowDown,
	faVolumeUp,
	faVolumeDown,
	faVolumeMute,
	faExpandArrowsAlt
} from '@fortawesome/free-solid-svg-icons';

// add the imported icons to the library
library.add(fab, faGlobe, faStop, faPlay, faPause, faTh, faArrowLeft, faArrowRight, faArrowUp, faArrowDown, faVolumeUp, faVolumeDown, faVolumeMute, faExpandArrowsAlt);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();